import TableCommonHook from '@/pages/opinion/components/TableCommonHook';
import { useSocialMediaColumns } from '@/pages/opinion/components/TableCommonHook/hooks/useSocialMediaColumns';
import { useRequestLatestEditLog } from '@op/pages/feeds/hooks/useFeedsRequest';
import React from 'react';
import { connect } from 'umi';

function SocialTable({
  gameInfo,
  wholeGameInfo,
  sortBy,
  setSortBy,
  isExcludeInvalid,
  setIsExcludeInvalid,
  total,
  records,
  hasPageable = true,
  tableSticky = true,
  pageInfo,
  setPageInfo,
  loading = false,
  languages,
  setLanguages,
  setApiLoading,
  renderKeyword,
  detailParams,
}: any) {
  const { logCommentMap, loading: logLoading } = useRequestLatestEditLog({
    data: records as any,
    setApiLoading,
  });

  const { columns, sortColumns } = useSocialMediaColumns({
    gameInfo,
    wholeGameInfo,
    languages,
    sort: sortBy,
    setSort: setSortBy,
    isExcludeInvalid,
    setIsExcludeInvalid,
    isSpecialChannel: false,
    logCommentMap,
    logLoading,
    setLanguages,
    renderKey: renderKeyword,
    detailParams,
  });

  return (
    <TableCommonHook
      minWidth={1600}
      recordKey="comment_uin"
      records={records}
      tableSticky={tableSticky}
      sortColumns={sortColumns}
      hasPageable={hasPageable}
      sortInfo={[sortBy, setSortBy]}
      pageInfo={pageInfo}
      columns={columns}
      total={total}
      loading={loading}
      setPageInfo={setPageInfo}
    />
  );
}

export default connect((state: any) => {
  const { opinionCommon } = state;

  return { 
    wholeGameInfo: opinionCommon.wholeGameInfo, 
  };
})(SocialTable);
